export default __webpack_public_path__ + "static/media/w_m_2025_h.bbd2ecff.jpg";